import React, { useState } from 'react';
//import './navbar.css';
import { Link } from "react-router-dom";
import JSONPretty from 'react-json-pretty';
import { Table, Row, Col } from 'react-bootstrap';
import Nuova_Ditta_Edit from "./Ditta_x0_1_edit";
import Visualizza_lista_documenti_pdf from "../Funzioni_comuni_pdf_visualizza.jsx";
//import { AiOutlineDownload } from 'react-icons/ai';
//import { BsTrash } from 'react-icons/bs';
//import axios from "axios";

const { Data_formattata } = require('../Funzioni_comuni')

const { Tipologia_Aziende, Tipologia_Aziende_lungo, Tipologia_Aziende_colore } = require('../Funzioni_comuni_tipologia_aziende')
const { Data_formattata1 } = require('../Funzioni_comuni_data_formattata')
const lista = Tipologia_Aziende()
const lista_colori = Tipologia_Aziende_colore()


const Visualizza_singola_ditta = (props) => {
//    const [somma, calcola_somma] = useState('');


    function Mostra_tipologia_azienda (tipo_corto) {

        const lista = Tipologia_Aziende()
        const lista_lunga = Tipologia_Aziende_lungo()
         let index = lista.indexOf(tipo_corto)
        
        return <>
             {lista_lunga[index]}
        </>
    }


    function processa_invio_mail (indice) {
        //        {/* idroslab esempio di render da ua funzione */}

        if (indice == -1)
        return <>
            Non inviata
        </>
        if (indice == 0)
        return <>
            Inviata
        </>
        if (indice == 1)
        return <>
            Risposta Ok!
        </>
    }


    function colorazione(tipo_corto) {

//        console.log(tipo_corto)
//        console.log(lista_colori)

        let index = lista.indexOf(tipo_corto)

        var hStyle = { backgroundColor: lista_colori[index], margin: '5px', padding: '5px' };
        return hStyle;
    }


    return (
    <div style={colorazione(props.item.tipologia)}>
        <Row>
        <Col>
            <Nuova_Ditta_Edit ditta={props.item} tutor={props.tutor} variab_aggiorna={props.variab_aggiorna} SET_variab_aggiorna={props.SET_variab_aggiorna} tutor={props.tutor}/>
        </Col>
    </Row>
    <Row>
        <Col>
        <ul>
        <li>    Ragione Sociale: <strong> {props.item.ragione_sociale}</strong>  </li>
        <li>    Tipologia: <strong> {Mostra_tipologia_azienda (props.item.tipologia)}</strong>  </li>

        </ul>
        </Col>
        <Col>
        <ul>
        
            <li>    Email: <strong>{props.item.email}</strong>  </li>
            <li>    Cf/Partita IVA: <strong>{props.item.partita_iva}</strong> </li>
            </ul>
            
        </Col>

        <Col>
        <ul>
        
            <li>    Mail Richiesta Dati1: <strong> {processa_invio_mail (props.item.inviata_mail_per_richesta_dati) } </strong>  </li>
            
            
            <li>    {props.item.inviata_mail_per_richesta_dati != -1 && <>
                        Data_Mail: <strong>{ Data_formattata1(props.item.inviata_mail_data)} </strong>
                    </>} 
            </li>
        </ul>
        </Col>

    </Row>


    {props.item.documentazione_array.length != 0 && <>             
        <Table striped bordered hover>
        <thead>
            <tr>
            <th>#</th>
            <th>Tipologia</th>
            <th>Data Caricamento</th>
            
            <th>Tutor</th>
            <th>Admin</th>
       
            <th>Azioni</th>
            </tr>
        </thead>
        <tbody>
                   {/*------------------ AGGIORNARE MONGO QRCODE ---------------------------*/}   
            
        <Visualizza_lista_documenti_pdf attore_tipo= {'ditta'} attore={props.item} tutor={props.tutor} tipologia_documento={'convenzione'} SET_variab_aggiorna={props.SET_variab_aggiorna}/> 
        <Visualizza_lista_documenti_pdf attore_tipo= {'ditta'} attore={props.item} tutor={props.tutor} tipologia_documento={'sicurezza'} SET_variab_aggiorna={props.SET_variab_aggiorna}/> 

        </tbody>
    </Table>
    </> }

    {(props.account_dati.utente_debug) &&
        <JSONPretty data={props.item} />
     }
    {/*
    // toolmemo 
        <hr class="rounded"></hr>
    */ }
    </div>
    )
}
export default Visualizza_singola_ditta;